module.exports = __webpack_public_path__ + "static/media/coursehero.8047ecb3.png";